export default {
    carregando: false,
    notificacoes: [],
}
